"use client"
import React from 'react';
import { useScopedI18n } from '@locales/client';
import { Button } from '@/shared/ui/form/button/button';
import { BodyTextRegularB, BodyTextMediumB, HeadingBoldH4 } from '@/shared/ui/typography2';
import * as Dialog from '@radix-ui/react-dialog';
import { StyledAlertDialogOverlay } from '@/shared/ui/alert-dialog/styles';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import {
  StyledPlayResponsiblyDialogContent,
  Navigation,
  InfoContainer,
  Title,
  Description,
  LogoPartnerWrapper,
  PagcorLogoImage,
  Badge21LogoImage,
  // закрытие временно отключено: флоу принудительный, закрыть нельзя, пока не подтверждён
  // CloseButton,
  // CloseIconImage,
} from './styles';
import { ButtonWrapper } from '@/features/login-confirmation-modal/styles';

interface PlayResponsiblyStepProps {
  isOpen: boolean;
  onAccept: () => void;
}

export const PlayResponsiblyStep = ({ isOpen, onAccept }: PlayResponsiblyStepProps) => {
  const t = useScopedI18n('login_confirmation_modal.play_responsibly');
  const tShared = useScopedI18n('login_confirmation_modal');
  const isClient = typeof window !== 'undefined';

  const title = t('title');
  const descriptionLine1 = t('description.0');
  const descriptionLine2 = t('description.1');
  const acceptButtonText = tShared('accept_button');

  if (!isClient) {
    return null;
  }

  return (
    // закрытие временно отключено: флоу принудительный, закрыть нельзя, пока не подтверждён
    // onOpenChange={onClose}
    <Dialog.Root open={isOpen} onOpenChange={() => {}}>
      <Dialog.Portal>
        <StyledAlertDialogOverlay />
        <StyledPlayResponsiblyDialogContent aria-describedby="" data-item="play_responsibly">
          <VisuallyHidden>
            <Dialog.Title>{title}</Dialog.Title>
          </VisuallyHidden>

          <InfoContainer>
            <Navigation>
              {/* закрытие временно отключено: флоу принудительный, закрыть нельзя, пока не подтверждён */}
              {/* <CloseButton onClick={onClose}>
                <CloseIconImage
                  src="/images/icons/close-dialog.svg"
                  alt={closeButtonText}
                />
              </CloseButton> */}
            </Navigation>

            <Title>
              <HeadingBoldH4 style={{ textAlign: 'center' }}>{title}</HeadingBoldH4>
            </Title>
            <Description>
              <BodyTextRegularB
                color="#AFAFAF"
                style={{ textAlign: 'center', whiteSpace: 'pre-line' }}
              >
                {descriptionLine1}
              </BodyTextRegularB>
            </Description>
            <Description>
              <BodyTextRegularB
                color="#AFAFAF"
                style={{ textAlign: 'center', whiteSpace: 'pre-line' }}
              >
                {descriptionLine2}
              </BodyTextRegularB>
            </Description>

            <LogoPartnerWrapper>
              <PagcorLogoImage src="/images/icons/logo-pagcor.svg" alt="PAGCOR" />
              <Badge21LogoImage
                src="/images/icons/logo-21.svg"
                alt="21+ Gambling can be addictive, know when to stop"
              />
            </LogoPartnerWrapper>
          </InfoContainer>

          <ButtonWrapper>
            <Button
              type="button"
              onClick={onAccept}
              variant="orangeGradient"
              fill
              data-analytics-id="play_responsibly"
            >
              <BodyTextMediumB>{acceptButtonText}</BodyTextMediumB>
            </Button>
          </ButtonWrapper>
        </StyledPlayResponsiblyDialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
